import { createReducer, on } from '@ngrx/store';
import { RolloutApiActions, RolloutListActions } from './automated-rollouts.actions';
import { adapter, initialState, selectBundleIdentifierFromAutomatedRollout } from './automated-rollouts.state';

export const automatedRolloutsReducer = createReducer(
  initialState,
  on(RolloutApiActions.rolloutAdded, (state, { addAutomatedConfigurationCommand }) =>
    adapter.upsertOne(addAutomatedConfigurationCommand, state)
  ),
  on(RolloutListActions.rolloutDeleted, (state, { automatedConfiguration }) =>
    adapter.removeOne(selectBundleIdentifierFromAutomatedRollout(automatedConfiguration), state)
  ),
  on(RolloutApiActions.rolloutsLoaded, (state, { automatedConfigurations }) =>
    adapter.upsertMany(automatedConfigurations, state)
  ),
  on(RolloutApiActions.rolloutUpdated, (state, { newAutomatedConfiguration }) =>
    adapter.updateOne(
      {
        id: newAutomatedConfiguration.id,
        changes: newAutomatedConfiguration,
      },
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAutomatedRolloutIds = selectIds;

export const selectAutomatedRolloutEntities = selectEntities;

export const selectAllAutomatedRollouts = selectAll;
